'use strict';
var $ = require('jquery'),
    width = window.innerWidth;

function moveSlide(slider, dir, slides) {
    var lastMovedSlide,
        slideWidth = slides.first().outerWidth(),
        offset = 3.2;

    lastMovedSlide = $(slider).find('.move').last();

    if (lastMovedSlide.length === 0 || !lastMovedSlide || lastMovedSlide.length === null) {
        // Register active slide on initial load
        slides
            .first()
            .css({'margin-left': '-' + slideWidth - offset + 'px'})
            .addClass('move');
    } else if (lastMovedSlide.length >= 1 && dir === 'right') {
        // Move active class to the right
        lastMovedSlide
            .next('.item-container')
            .css({'margin-left': '-' + slideWidth - offset + 'px'})
            .addClass('move');
    } else if (lastMovedSlide.length >= 1 && dir === 'left') {
        // Move active class to the left
        lastMovedSlide.css({'margin-left': '0px'}).removeClass('move');
    }

    lastMovedSlide = $(slider).find('.move').last();

    return lastMovedSlide;
}

function getNumToShow(listEl) {
    var numToShow = parseInt(listEl.data('element-num'));

    if (width <= 767) {
        numToShow = 1;
    } else if (width <= 1023) {
        numToShow = 3;
    } else if (numToShow > 4 && width >= 1024 && width <= 1280) {
        numToShow = 4;
    } else if (numToShow > 4 && width >= 1280) {
        numToShow = 5;
    }

    return numToShow;
}

function toggleButtonAbility(listEl, slides, lastMoved) {
    var btnLeftEl = listEl.find('.left-btn'),
        btnRightEl = listEl.find('.right-btn'),
        stopSliderAtIndex = slides.length - getNumToShow(listEl) - 1;

    //enables and disables buttons
    if (stopSliderAtIndex === $(lastMoved).index()) {
        btnRightEl.addClass('disabled');
    } else {
        btnRightEl.removeClass('disabled');
    }

    if (listEl.find('.move') === null || listEl.find('.move').length === 0 || !listEl.find('.move')) {
        btnLeftEl.addClass('disabled');
    } else {
        btnLeftEl.removeClass('disabled');
    }
}

//check for IE
function msieversion() {
    var ua = window.navigator.userAgent,
        msie = ua.indexOf('MSIE '),
        edge = ua.indexOf('Edge');

    if (msie > 0 || edge > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        return true;
    } else {
        return false;
    }
}

module.exports = {
    init: function () {
        $('.slider-arrow').on('click', function () {
            var sliderArrow = $(this),
                slider = $(sliderArrow).closest('.product-slider'),
                dir = sliderArrow.data('direction'),
                slides = $(slider).find('.item-container');

            toggleButtonAbility(slider, slides, moveSlide(slider, dir, slides));
        });

        $(window).on('resize', function () {
            width = window.innerWidth;
        });

        $('.product-slider')
            .not('.loaded')
            .each(function () {
                var btnHldr = $(this).find('.slider-btn-hldr'),
                    slides = $(this).find('.item-container');

                if (slides.length <= 3) {
                    btnHldr.hide();
                }
            });
    }
};
